// extracted by css-extract-rspack-plugin
module.exports =  {"card":"AddGroupCard-m_jy__card","image":"AddGroupCard-bFD5__image","button-outer":"AddGroupCard-l5nU__button-outer"};